<script>
import formInput from "@/mixins/shared/formInput";

export default {
	mixins: [formInput],
	props: {
		'groupClasses': {
			type: String,
			required: false
		},
		'label': {
			type: String,
			required: false
		}
	}
}
</script>

<template>
	<div class="input-group align-items-start">
		<span class="input-group-text" v-if="$slots.addonbefore">
			<slot name="addonbefore" />
		</span>
		<textarea v-bind="$attrs" :name="name" @input="changeModelValue" :id="renderedId" :class="{'form-control': true, 'border-danger': hasError}" :value="modelValue"></textarea>
		<span class="input-group-text" v-if="$slots.addonafter">
			<slot name="addonafter" />
		</span>
	</div>
	<div v-if="$slots.descriptionbottom" class="input-description mt-2">
		<slot name="descriptionbottom" />
	</div>
	<label v-if="hasError" class="text-danger mt-2 small">{{ this.form.errors[this.name] }}</label>
</template>